import axios from 'axios';

// Use api.joinmane.com in production, localhost:4000 in development
const baseURL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4000/api'
  : 'https://api.joinmane.com/api';

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

const token = localStorage.getItem('fu_token');
if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export default api;
